import React from 'react';
import { FormControl, FormLabel } from '@mui/material';
import { AdminBrokerGroupPicker } from '../../shared/pickers/AdminBrokerGroupPicker';
import { AdminLedgerPicker } from '../../shared/pickers/AdminLedgerPicker';
import { AdminYesNoPicker } from '../../shared/pickers/AdminYesNoPicker';
import { UserStatusPicker } from './UserStatusPicker';

const FILTERS = [
	{ field: 'status', label: 'Status', Picker: UserStatusPicker },
	{ field: 'brokerGroups', label: 'Broker group', Picker: AdminBrokerGroupPicker },
	{ field: 'ledgers', label: 'Ledger', Picker: AdminLedgerPicker },
	{ field: 'canViewGroup', label: 'Can view group', Picker: AdminYesNoPicker },
];

/**
 * The users table's filters, one element per filter for AdminListToolbar (see
 * useUserFilter). Each has "All" and "Clear Filter" options. Values are saved in the admin
 * table prefs through useAdminListParams' filters / setFilter.
 */
export const getUserFilters = ({ filters, setFilter }) =>
	FILTERS.map(({ field, label, Picker }) => (
		<FormControl key={field} fullWidth>
			<FormLabel>{label}</FormLabel>
			<Picker
				value={filters[field] ?? []}
				onChange={(values) => setFilter(field, values.length ? values : undefined)}
				showCheckbox
				showAllOption
				showClearOption
			/>
		</FormControl>
	));
